var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.ruleForm, "label-width": "100px" },
    },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            label: "网点名称：",
            prop: "storeName",
            rules: {
              required: true,
              message: "网点名称不能为空",
              trigger: "blur",
            },
          },
        },
        [
          _c("el-input", {
            staticClass: "selWidth",
            model: {
              value: _vm.ruleForm.storeName,
              callback: function ($$v) {
                _vm.$set(
                  _vm.ruleForm,
                  "storeName",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "ruleForm.storeName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: "负责人：",
            prop: "businessLicense",
            rules: {
              required: true,
              message: "负责人不能为空",
              trigger: "blur",
            },
          },
        },
        [
          _c("el-input", {
            staticClass: "selWidth",
            model: {
              value: _vm.ruleForm.businessLicense,
              callback: function ($$v) {
                _vm.$set(
                  _vm.ruleForm,
                  "businessLicense",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "ruleForm.businessLicense",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: "联系电话：",
            prop: "phone",
            rules: {
              required: true,
              message: "手机号码不能为空",
              trigger: "blur",
            },
          },
        },
        [
          _c("el-input", {
            staticClass: "selWidth",
            model: {
              value: _vm.ruleForm.phone,
              callback: function ($$v) {
                _vm.$set(
                  _vm.ruleForm,
                  "phone",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "ruleForm.phone",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "营业时间：" } },
        [
          _c("el-time-select", {
            attrs: {
              placeholder: "起始时间",
              "picker-options": {
                start: "08:30",
                step: "00:15",
                end: "18:30",
              },
            },
            model: {
              value: _vm.ruleForm.startTime,
              callback: function ($$v) {
                _vm.$set(_vm.ruleForm, "startTime", $$v)
              },
              expression: "ruleForm.startTime",
            },
          }),
          _vm._v(" "),
          _c("el-time-select", {
            attrs: {
              placeholder: "结束时间",
              "picker-options": {
                start: "08:30",
                step: "00:15",
                end: "18:30",
                minTime: _vm.ruleForm.startTime,
              },
            },
            model: {
              value: _vm.ruleForm.endTime,
              callback: function ($$v) {
                _vm.$set(_vm.ruleForm, "endTime", $$v)
              },
              expression: "ruleForm.endTime",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "商品轮播图：", prop: "sliderImages" } },
        [
          _c(
            "div",
            { staticClass: "acea-row" },
            [
              _vm._l(_vm.ruleForm.sliderImages, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "pictrue",
                    attrs: { draggable: "true" },
                    on: {
                      dragstart: function ($event) {
                        return _vm.handleDragStart($event, item)
                      },
                      dragover: function ($event) {
                        $event.preventDefault()
                        return _vm.handleDragOver($event, item)
                      },
                      dragenter: function ($event) {
                        return _vm.handleDragEnter($event, item)
                      },
                      dragend: function ($event) {
                        return _vm.handleDragEnd($event, item)
                      },
                    },
                  },
                  [
                    _c("img", { attrs: { src: item } }),
                    _vm._v(" "),
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isDisabled,
                          expression: "!isDisabled",
                        },
                      ],
                      staticClass: "el-icon-error btndel",
                      on: {
                        click: function ($event) {
                          return _vm.handleRemove(index)
                        },
                      },
                    }),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.ruleForm.sliderImages.length < 10 && !_vm.isDisabled
                ? _c("el-upload", {
                    ref: "upload",
                    staticStyle: { width: "50%" },
                    attrs: {
                      action: "",
                      limit: 10,
                      "http-request": _vm.uploadFile,
                      "show-file-list": false,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "trigger",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "upLoadPicBox" }, [
                                _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3132204842
                    ),
                  })
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "区域：" } },
        [
          _c("el-cascader", {
            staticClass: "selWidth",
            attrs: { options: _vm.regSelect, props: _vm.regProps },
            on: { change: _vm.handleChange },
            model: {
              value: _vm.ruleForm.region,
              callback: function ($$v) {
                _vm.$set(_vm.ruleForm, "region", $$v)
              },
              expression: "ruleForm.region",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: "详细地址：",
            prop: "address",
            rules: {
              required: true,
              message: "详细地址不能为空",
              trigger: "blur",
            },
          },
        },
        [
          _c("el-input", {
            staticClass: "selWidth",
            attrs: { type: "textarea" },
            model: {
              value: _vm.ruleForm.address,
              callback: function ($$v) {
                _vm.$set(
                  _vm.ruleForm,
                  "address",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "ruleForm.address",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "经纬度：" } },
        [
          _c("el-input", {
            staticClass: "selWidth",
            model: {
              value: _vm.ruleForm.map,
              callback: function ($$v) {
                _vm.$set(
                  _vm.ruleForm,
                  "map",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "ruleForm.map",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function ($event) {
                  return _vm.getMapGeo()
                },
              },
            },
            [_vm._v("获取经纬度")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("ruleForm")
                },
              },
            },
            [_vm._v("提交")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("ruleForm")
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }